import {FETCH_DISPATCH_PLANS_TABLE_DATA,FETCH_DISPATCH_PLANS_STATUS_COUNT, FETCH_DISPATCH_PLANS_CARDWISE_COUNT} from "../types"

const INIT_STATE = {
    dispatchPlanTableData: [],
    dispatchPlanTableDataRows: 0,
    // rmStockDetail: null,
    // inHousePalletDetailItemCount: 0,
    dispatchPlanCardTypeWiseCount:null,
    // hygieneMaterialCardTypeWiseCount:null,
    // skuGroupDetail: null,
    dispatchPlanStatusWiseCount: null,
    // serricoMappedData: [],
    // serricoMappedDataCount: 0
    // inHouseDePalletizationStatusWiseCount: null,
    // inHousePickingReadyPallets: null,
    // inHouseDePalletizationTableData: [],
    // totalDePalletTableDataRows: 0,
    // automationRuleTableData: [],
    // automationRuleTableRows: 0,
    // automationTaskFields: null,
    // jobTypeListsByWorkflow: []


}
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_DISPATCH_PLANS_TABLE_DATA: return { ...state, dispatchPlanTableData: action?.payload?.data || [], dispatchPlanTableDataRows: action?.payload?.count || 0 }
        // case FETCH_RM_STOCK_DETAIL: return {...state, rmStockDetail: action?.payload|| null}
        case FETCH_DISPATCH_PLANS_STATUS_COUNT: return { ...state, dispatchPlanStatusWiseCount: action?.payload}
        case FETCH_DISPATCH_PLANS_CARDWISE_COUNT: return { ...state, dispatchPlanCardTypeWiseCount: action?.payload}
        // case FETCH_HYGIENE_MATERIAL_CARDTYPEWISE_COUNT: return { ...state, hygieneMaterialCardTypeWiseCount: action?.payload}
        // case FETCH_INHOUSE_PALLET_PICKING_READY: return { ...state, inHousePickingReadyPallets: action?.payload}
        // case FETCH_INHOUSE_DEPALLETIZATION_TABLE_DATA: return { ...state, inHouseDePalletizationTableData: action?.payload?.data || [], totalDePalletTableDataRows: action?.payload?.count || 0 }
        // case FETCH_INHOUSE_DEPALLET_STATUS_COUNT: return { ...state, inHouseDePalletizationStatusWiseCount: action?.payload}
        // case FETCH_QUALITYCHECK_CARD_COUNT: return { ...state, qualityCheckCardTypeWiseCount: action?.payload}
        // case FETCH_SERRICO_MAPPED_DATA: return { ...state, serricoMappedData: action?.payload?.data || [], serricoMappedDataCount: action?.payload?.count || 0 }

        // case FETCH_SKU_GROUP_DETAIL: return { ...state, skuGroupDetail: action?.payload?.data || {} }
        // case FETCH_AUTOMATION_TASK_FIELDS: return { ...state, automationTaskFields: action?.payload?.data || {} }
        // case FETCH_JOB_TYPES_BY_WORKFLOW: return { ...state, jobTypeListsByWorkflow: action?.payload?.data || [] }

        default: return state
    }
}